module.exports = __webpack_public_path__ + "fonts/opensans-light.d2947d40.woff";